import React from 'react';
import { FDStack, FDImage, FDPaper } from '@facet-wealth/design';
import fr from 'facet-rest';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';

export const FeaturedInWidget = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  const renderImage = (rel) => (
    <FDImage
      src={rel.link('related').url()}
      alt={rel.meta('altText') || ''}
      aspectRatio={rel.meta('aspectRatio')}
      rounded={false}
    />
  );

  return (
    <FDPaper appearance={'flat'} color={isMobile ? 'subtle' : undefined}>
      <FDStack direction={'column'} padding={isMobile ? 2 : 4} spacing={2} flex={1} width={'100%'} alignItems={'center'} justifyContent={isMobile ? 'center' : undefined}>
        <MetaControlField attr={'influencerFeaturedInSectionTitle'} />
        <FDStack direction={'row'} justifyContent={'center'} spacing={2} wrap>
          {resource.withRelationship(fr.relationships.newYorkTimesLogo.name,
            (rel) => renderImage(rel),
            () => null)}
          {resource.withRelationship(fr.relationships.businessInsiderLogo.name,
            (rel) => renderImage(rel),
            () => null)}
          {resource.withRelationship(fr.relationships.forbesLogo.name,
            (rel) => renderImage(rel),
            () => null)}
          {resource.withRelationship(fr.relationships.wallStreetJournalLogo.name,
            (rel) => renderImage(rel),
            () => null)}
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};
